export default __webpack_public_path__ + "static/media/Calendar.494fd12d.svg";